import { DateTime } from 'luxon';
import JsBarcode from 'jsbarcode';
import { SampleTagResponse } from '../types';
import {
  PROTO_DEVELOPMENT_COLORS,
  SAMPLE_TYPE_COLORS,
  FABRIC_SECTION_NAMES,
} from './constants';
import { styles } from './styles';
import fnLogo from '../../../../Assets/images/fn_logo.png';
import novamenLogo from '../../../../Assets/images/novamen-logo.png';
import novakidsLogo from '../../../../Assets/images/novakids-logo.png';

export const formatSampleTypeDisplay = (type: string) => {
  if (type === 'Proto Development') return type;
  return type && !type.includes('Sample') ? `${type} Sample` : type;
};

export const selectLogo = (division?: string) => {
  const normalizedDivision = division?.toLowerCase().trim();
  if (normalizedDivision === "men's") {
    return novamenLogo;
  }
  if (normalizedDivision === "kid's") {
    return novakidsLogo;
  }
  return fnLogo;
};

type LogoType = typeof fnLogo | typeof novamenLogo | typeof novakidsLogo;

export const getLogoDimensions = (selectedLogo: LogoType, logoWidth = 170) => {
  if (selectedLogo === novakidsLogo) {
    return { width: 90, height: 15 };
  }
  if (selectedLogo === novamenLogo) {
    return { width: 110, height: 15 };
  }

  return { width: logoWidth, height: 13 };
};

export const getBorderColor = (
  sampleType: string,
  developmentType?: string,
) => {
  if (sampleType === 'Proto Development' && developmentType) {
    return PROTO_DEVELOPMENT_COLORS[developmentType];
  }
  return SAMPLE_TYPE_COLORS[sampleType];
};

export const getContainerStyle = (
  sampleType: string,
  developmentType?: string,
) => {
  const borderColor = getBorderColor(sampleType, developmentType);
  return {
    ...styles.container,
    border: `15px solid ${borderColor}`,
  };
};

export const formatDate = (dateString?: string) => {
  if (!dateString) return '-';
  const date = DateTime.fromISO(dateString);
  return date.toFormat('MM/dd/yy');
};

export const formatDateUTC = (dateString?: string) => {
  if (!dateString) return '-';
  return DateTime.fromISO(dateString, { zone: 'utc' }).toFormat('MM/dd/yy');
};

export const generateBarcode = (value: string | undefined) => {
  if (!value || value.trim() === '') {
    const canvas = document.createElement('canvas');
    canvas.width = 100;
    canvas.height = 40;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, 100, 40);
    }
    return canvas.toDataURL();
  }

  const canvas = document.createElement('canvas');
  try {
    JsBarcode(canvas, value, {
      format: 'CODE128',
      width: 2,
      height: 40,
      displayValue: false,
      background: '#ffffff',
      lineColor: '#000000',
    });
    return canvas.toDataURL();
  } catch (error) {
    console.error('Barcode generation failed:', error);
    canvas.width = 100;
    canvas.height = 40;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, 100, 40);
    }
    return canvas.toDataURL();
  }
};

export const getFabricSections = (tagData: SampleTagResponse) =>
  FABRIC_SECTION_NAMES.map((sectionName) => {
    const sectionData = tagData?.[sectionName];

    const fiberContent =
      sectionData?.content
        ?.map((fiber) => `${fiber.fiber} ${fiber.percent_of_fibers}%`)
        .join(' ') || '';

    return {
      type: sectionName
        ? sectionName.charAt(0).toUpperCase() + sectionName.slice(1)
        : '',
      content: fiberContent,
      weight: sectionData?.fabric_weight?.toString() || '',
    };
  });
